// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EArkisto_symbolGrid__eJnoS{display:grid;grid-template-columns:repeat(5, 200px);grid-gap:10px;gap:10px}", "",{"version":3,"sources":["webpack://./src/nonRouteFeatures/EArkisto/styles.scss"],"names":[],"mappings":"AAAuC,4BACrC,YAAA,CACA,sCAAA,CACA,aAAA,CAAA,QAAA","sourcesContent":["@import \"assets/styles/variables.scss\";.symbolGrid {\n  display: grid;\n  grid-template-columns: repeat(5, 200px);\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"symbolGrid": "EArkisto_symbolGrid__eJnoS"
};
export default ___CSS_LOADER_EXPORT___;
